<app-verification class="verification-root" *transloco="let t" [formGroup]="codeFormGroup" (clickSubmit)="onSubmit()">
  <app-main-header header>{{ t('verification') }}</app-main-header>
  <app-label isBig title>{{ t('verify-email')}}</app-label>
  <app-paragraph instructions>
    {{ t('verification-instructions-1') }}
  </app-paragraph>
  <app-circle image size="small">mail</app-circle>
  <span verificationEmail id="email-verification">
    {{ t('verification-instructions-2') }}<span class="verification-page-email"> {{this.username}}</span>
  </span>
  <span codeTitle>{{ t('verification-instructions-10') }}</span>
  <app-code-input codeInput id="verification-page-code-input" [control]="codeFormControl"></app-code-input>
  <app-label id="verification-page-invalid-code-error-message" *ngIf="!successfulSent" message isError>{{ t('invalid-code') }}</app-label>
  <ul bulletPoints>
    <li><span>{{ t('verification-instructions-3') }} <span class="verification-page-resend-verification-code-instructions" (click)="onResend()">{{ t('verification-instructions-4') }}</span>{{ t('verification-instructions-5') }}</span></li>
    <li><span>{{ t('verification-instructions-6') }} </span></li>
    <li><span>{{ t('verification-instructions-7') }} <span class="verification-page-resend-verification-code-instructions" (click)="navigateToFAQPage()">{{ t('verification-instructions-8') }}</span>{{ t('verification-instructions-9') }}</span></li>
  </ul>
  <div buttonSection>
    <app-primary-button id="verification-page-verify" type="submit" [abstractControl]="codeFormGroup">
      {{ t('verify') }}
    </app-primary-button>
  </div>
</app-verification>
